const pendingResolvers = new Set<(value?: undefined) => void>();

function resolvePendingPromises() {
  for (const resolve of pendingResolvers) resolve();
  pendingResolvers.clear();
}

export function yieldUnlessUrgent() {
  return new Promise((resolve: (value?: undefined) => void) => {
    pendingResolvers.add(resolve);
    if (document.visibilityState === 'visible') {
      document.addEventListener('visibilitychange', resolvePendingPromises);
      document.addEventListener('pagehide', resolvePendingPromises);
      return requestAnimationFrame(() =>
        setTimeout(() => {
          pendingResolvers.delete(resolve);
          resolve();
        }),
      );
    }
    resolvePendingPromises();
  });
}
